import { render, staticRenderFns } from "./shortage_calculation.vue?vue&type=template&id=133e34bc&scoped=true&"
import script from "./shortage_calculation.vue?vue&type=script&lang=js&"
export * from "./shortage_calculation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133e34bc",
  null
  
)

export default component.exports